import { Version } from './Version';

/**
 * Appended build hash to the translation fetch request.
 * Translation files from 'assets/translations' are cached in the browser using the build hash,
 * while '/apps/translations' have proper caching in the header.
 */
export const buildHashParam =
  Version.buildHash && TRANSLATION_PATH === 'assets' ? { params: { buildHash: Version.buildHash } } : {}; // Avoids using build hash in Storybook
